export default __webpack_public_path__ + "static/medialink-5cd24677adffc8570d598ad8b2147836.jpg";